import { ChevronLeft, ChevronRight } from 'lucide-react'
import './Pagination.css'

interface PaginationProps {
  page: number
  pageSize: number
  total: number
  onPageChange: (page: number) => void
}

export default function Pagination({ page, pageSize, total, onPageChange }: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize))
  if (totalPages <= 1) return null

  return (
    <nav className="pagination" aria-label="Pagination" data-testid="pagination">
      <button
        className="pagination__btn"
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
        aria-label="Previous page"
        data-testid="pagination-prev"
        data-analytics-event="pagination-prev"
      >
        <ChevronLeft size={16} aria-hidden="true" />
        Prev
      </button>
      <span className="pagination__info" data-testid="pagination-info">
        Page {page} of {totalPages}
      </span>
      <button
        className="pagination__btn"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
        aria-label="Next page"
        data-testid="pagination-next"
        data-analytics-event="pagination-next"
      >
        Next
        <ChevronRight size={16} aria-hidden="true" />
      </button>
    </nav>
  )
}
